import * as THREE from "three";

/** Bake a height field into a repeating canvas normal map. */
export function heightMapToNormalMap(
  size: number,
  heightMap: Float32Array,
  intensity: number,
): THREE.CanvasTexture {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get canvas context for procedural normal-map");
  }

  const imageData = ctx.createImageData(size, size);
  const data = imageData.data;

  const getHeight = (px: number, py: number) => {
    const pxWrapped = ((px % size) + size) % size;
    const pyWrapped = ((py % size) + size) % size;
    return heightMap[pyWrapped * size + pxWrapped] ?? 0;
  };

  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      const hL = getHeight(x - 1, y);
      const hR = getHeight(x + 1, y);
      const hD = getHeight(x, y - 1);
      const hU = getHeight(x, y + 1);

      const dx = (hR - hL) * intensity;
      const dy = (hU - hD) * intensity;
      const dz = Math.sqrt(Math.max(0, 1 - dx * dx - dy * dy));

      const index = (y * size + x) * 4;
      data[index] = Math.floor((dx * 0.5 + 0.5) * 255);
      data[index + 1] = Math.floor((dy * 0.5 + 0.5) * 255);
      data[index + 2] = Math.floor((dz * 0.5 + 0.5) * 255);
      data[index + 3] = 255;
    }
  }

  ctx.putImageData(imageData, 0, 0);

  const texture = new THREE.CanvasTexture(canvas);
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  return texture;
}
